import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white p-3 shadow-md rounded-md" }
const _hoisted_2 = { class: "font-bold py-2" }
const _hoisted_3 = { class: "p-2" }
const _hoisted_4 = { class: "p-2 my-5 flex justify-center sm:w-[14%] w-1/2 border-2 rounded border-[#79B5E1]" }
const _hoisted_5 = {
  key: 0,
  class: "bg-[#FAFAFA] p-4 border-2 border-h-success-200 rounded"
}
const _hoisted_6 = { class: "flex flex-row items-center pb-2 gap-2" }
const _hoisted_7 = {
  key: 1,
  class: "bg-[#FAFAFA] p-4 border-2 border-h-error-100 rounded"
}
const _hoisted_8 = { class: "flex flex-row items-center pb-2 gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.answer.question?.prompt), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answer.question?.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, [
            _createElementVNode("b", null, _toDisplayString(String.fromCharCode(65 + index)) + ".", 1),
            _createTextVNode(" " + _toDisplayString(item.answerText), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_ctx.answer.studentAnswers?.[index] ? "Verdadeiro" : "Falso"), 1)
          ]),
          (_ctx.answer.studentAnswers?.[index] === item.correctAnswer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_v_icon, {
                    name: "hi-solid-check-circle",
                    scale: 1.3,
                    class: "text-[#74B543]"
                  }, null, 8, ["scale"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Resposta certa",
                en: "Correct response",
              })), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(item.answerDescription), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_v_icon, {
                    name: "hi-solid-x-circle",
                    scale: 1.3,
                    class: "text-[#BB414A]"
                  }, null, 8, ["scale"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Resposta incorreta",
                en: "Incorrect response",
              })), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(item.answerDescription), 1)
              ]))
        ])
      ]))
    }), 128))
  ]))
}